var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout p-4"},[_vm._v("Redireccionando...")])
}
var staticRenderFns = []

export { render, staticRenderFns }